// ==========================================
// src/constants/countries.js
// ==========================================

// Mapas de países e idiomas para campanhas do Google Ads

export const countries = [
  { code: 'US', name: '🇺🇸 United States', lang: 'en' },
  { code: 'BR', name: '🇧🇷 Brasil', lang: 'pt' },
  { code: 'GB', name: '🇬🇧 United Kingdom', lang: 'en' },
  { code: 'CA', name: '🇨🇦 Canada', lang: 'en' },
  { code: 'AU', name: '🇦🇺 Australia', lang: 'en' },
  { code: 'DE', name: '🇩🇪 Germany', lang: 'de' },
  { code: 'FR', name: '🇫🇷 France', lang: 'fr' },
  { code: 'ES', name: '🇪🇸 Spain', lang: 'es' },
  { code: 'IT', name: '🇮🇹 Italy', lang: 'it' },
  { code: 'MX', name: '🇲🇽 Mexico', lang: 'es' },
  { code: 'AR', name: '🇦🇷 Argentina', lang: 'es' },
  { code: 'PT', name: '🇵🇹 Portugal', lang: 'pt' },
  { code: 'NL', name: '🇳🇱 Netherlands', lang: 'en' },
  { code: 'BE', name: '🇧🇪 Belgium', lang: 'fr' },
  { code: 'CH', name: '🇨🇭 Switzerland', lang: 'de' },
  { code: 'AT', name: '🇦🇹 Austria', lang: 'de' },
  { code: 'SE', name: '🇸🇪 Sweden', lang: 'en' },
  { code: 'NO', name: '🇳🇴 Norway', lang: 'en' },
  { code: 'DK', name: '🇩🇰 Denmark', lang: 'en' },
  { code: 'FI', name: '🇫🇮 Finland', lang: 'en' },
  { code: 'IE', name: '🇮🇪 Ireland', lang: 'en' },
  { code: 'PL', name: '🇵🇱 Poland', lang: 'en' },
  { code: 'CZ', name: '🇨🇿 Czech Republic', lang: 'en' },
  { code: 'GR', name: '🇬🇷 Greece', lang: 'en' },
  { code: 'RO', name: '🇷🇴 Romania', lang: 'en' },
  { code: 'NZ', name: '🇳🇿 New Zealand', lang: 'en' },
  { code: 'SG', name: '🇸🇬 Singapore', lang: 'en' },
  { code: 'HK', name: '🇭🇰 Hong Kong', lang: 'en' },
  { code: 'JP', name: '🇯🇵 Japan', lang: 'en' },
  { code: 'IN', name: '🇮🇳 India', lang: 'en' },
  { code: 'AE', name: '🇦🇪 UAE', lang: 'en' },
  { code: 'ZA', name: '🇿🇦 South Africa', lang: 'en' },
  { code: 'CL', name: '🇨🇱 Chile', lang: 'es' },
  { code: 'CO', name: '🇨🇴 Colombia', lang: 'es' },
  { code: 'PE', name: '🇵🇪 Peru', lang: 'es' },
];

// Helper para pegar país por código
export const getCountryByCode = (code) => {
  return countries.find(c => c.code === code) || countries[0];
};

// Helper para pegar idioma do país
export const getLanguageByCountry = (code) => {
  const country = getCountryByCode(code);
  return country.lang || 'en';
};